export function CircularMetric({
  progress,
  label,
  size = 170,
  color = '#3B82F6',
}: {
  progress: number;
  label: string;
  size?: number;
  color?: string;
}) {
  const radius = 44;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress);
  return (
    <div className="mx-auto" style={{ width: size, height: size }}>
      <svg viewBox="0 0 100 100" width={size} height={size}>
        <circle cx="50" cy="50" r={radius} fill="none" stroke="currentColor" className="text-black/10 dark:text-white/10" strokeWidth={9} />
        <circle
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={9}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(-90 50 50)"
        />
        <text x="50" y="55" textAnchor="middle" fontSize="18" fontWeight="700" fill="currentColor">
          {label}
        </text>
      </svg>
    </div>
  );
}
